// Unique code to get top level Page Component and Page SCSS
// The only thing different is the from part should match your component

// All boilerplate cut/paste stuff
/* eslint-disable-next-line  import/newline-after-import */
/* eslint-disable-next-line   import/first */
import ReactDOM from 'react-dom';
import React from 'react';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';
import PAGE_COMPONENT from './SingleContentPage';
/* eslint-disable-next-line  no-undef */
const props = globalPageProps || {};
ReactDOM.hydrate(
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>,
    document.getElementById('root')
);

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'Community/SingleContentPage/SingleContentPage,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

*/
